import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { CardResource } from 'src/app/interfaces/card-resouce';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { CardService } from 'src/app/services/card.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-edit-card',
  templateUrl: './edit-card.component.html',
  styleUrls: ['./edit-card.component.scss']
})
export class EditCardComponent implements OnInit {
  /***
   * The FOrm to edit a CustomerCard
   */
  addForm: UntypedFormGroup;
  /**
   * the current Card => set via URL
   */
  currentCard: CardResource;
  /**
   * is the page finished Loading?
   */
  finishedLoading: boolean = false;
  /**
   * the QR Code of a Customercard
   */
  qr;
  /**
   * The State of customerCards
   */
  states = [
    { value: 'CREATED', viewValue: 'Erstellt', 'state': true },
    { value: 'AVAILABLE', viewValue: 'Verfügbar', 'state': true },
    { value: 'REQUESTED', viewValue: 'Angefordert', 'state': false },
    { value: 'ASSIGNED', viewValue: 'Zugeordnet', 'state': false },
    { value: 'ACTIVE', viewValue: 'Aktiv', 'state': false },
    { value: 'CLOSE_REQUEST', viewValue: 'Sperrung beantrag', 'state': false },
    { value: 'CLOSED', viewValue: 'Gesperrt', 'state': true }
  ]
/**
 * constructor
 * Init the Form
 * @param fb 
 * @param overlayService 
 * @param router 
 * @param route 
 * @param cardSerive 
 * @param businessuserService 
 * @param sanitizer 
 */
  constructor(
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute,
    private cardSerive: CardService,
    private businessuserService: BusinessuserService,
    private sanitizer: DomSanitizer) {
    this.addForm = this.fb.group({
      number: ['', [Validators.required]],
      state: ['', [Validators.required]],
      owner: ['', [Validators.required]],
    })
  }
  /**
   * ngOnInit
   * Get a Card and load all data (QR-Code)
   */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.cardSerive.getCard(params['id']).subscribe((card: any) => {
        this.currentCard = card;
        this.cardSerive.getCardQRCode(card).subscribe(val => {
          let objectURL = URL.createObjectURL(val);
          this.qr = this.sanitizer.bypassSecurityTrustUrl(objectURL);
          console.log(this.qr)
        })
        this.businessuserService.getBusinessUser(card.ownerPublicId).subscribe((user: BusinessUserResource) => {
          this.addForm.patchValue(card);
          this.addForm.patchValue({
            owner: user.person.displayName
          });
          this.addForm.disable()
          this.finishedLoading = true;
        })
      },
        error => {
          console.log("error: ", error);
          this.overlayService.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
        })
    })
  }

  /**
   * TODO
   * edit a Card
   */
  editCard() {
  }

}
